import { useEffect, useState } from "react";
import { withRouter, useParams } from "react-router";
import { search } from "ionicons/icons";
import {
  fetchGuardarMedidasImagen,
  fetchListarMedidas,
  fetchMedidasProcedimiento,
  fetchMedidasRutinas,
  fetchPersonas,
  IfetchPersonas,
} from "../services/Fiscalizacion/Fiscalizacion";
import {
  IonContent,
  IonPage,
  IonIcon,
  IonInput,
  IonItem,
  useIonToast,
} from "@ionic/react";
import Header from "../../src/components/Header";
import PanelFiscalizacion from "../../src/components/Fiscalizacion/PanelFiscalizacion";
import "./Fiscalizacion.css";
import React from "react";
import {
  fetchCalificaciones,
  ICalificaciones,
  IMedidasCorrectivas,
} from "src/services/Fiscalizacion/Deposito";
import { dateAFormatoGlobal, diaSiguiente } from "src/utils";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  DialogContent,
  DialogActions,
  Dialog,
  DialogTitle,
} from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import ComentarioFiscalizacion from "src/components/Fiscalizacion/ComentarioFiscalizacion";
import { useFiscalizacion } from "src/components/Fiscalizacion/FiscalizacionContext";

interface Params {
  fis_id: string;
  nombre: string;
  codigo: string;
  objetivo: string;
  ps_id: string;
}

const FiscalizarPersonal: React.FC = () => {
  const PERSONAS_POR_PAGINA = 5;
  const { setInformacionFiscalizacion } = useFiscalizacion();
  const { ps_id, nombre, codigo, fis_id, objetivo } = useParams<Params>();
  const [personasAsignadas, setPersonasAsignadas] = useState<IfetchPersonas[]>(
    []
  );
  const [legajo, setLegajo] = useState(0);
  const [filtroBusqueda, setFiltroBusqueda] = useState("");
  const [calificaciones, setCalificaciones] = useState<ICalificaciones[]>([]);
  const [calificacionSeleccionada, setCalificacionSeleccionada] = useState<
    number | null
  >(1);
  const [calificacionesPorPersona, setCalificacionesPorPersona] = useState({});
  const [medidasCorrectivas, setMedidasCorrectivas] = useState<
    IMedidasCorrectivas[]
  >([]);
  const [medidaCorrectivaSeleccionada, setMedidaCorrectivaSeleccionada] =
    useState<number | null>(1);
  const [isSubmitted] = useState(false);
  const [present] = useIonToast();
  const tomorrow = diaSiguiente(new Date());
  const maxDate = dateAFormatoGlobal(tomorrow);
  const [openDialog, setOpenDialog] = useState(false);
  const [fechaModificada, setFechaModificada] = React.useState<any>({
    fechaModificada: null,
  });
  const [dialogType, setDialogType] = useState<string>("");
  const [paginaActual, setPaginaActual] = useState(1);

  useEffect(() => {
    const cargarDatos = async () => {
      const resCalificaciones = await fetchCalificaciones();
      const resMedidas = await fetchListarMedidas();
      if (resCalificaciones.datos) {
        const calificacionesFiltradas = resCalificaciones.datos
          .filter((calificacion) => [0, 1, 2, 3, 4].includes(calificacion.id))
          .flat();
        setCalificaciones(calificacionesFiltradas);
      }
      if (resMedidas.datos) {
        const medidasFiltradas = resMedidas.datos
          .filter((medida) => [0, 1, 2, 3, 4, 5].includes(medida.id))
          .flat();
        setMedidasCorrectivas(medidasFiltradas);
      }
    };
    cargarDatos();
  }, []);

  const personasFiltradas = personasAsignadas.filter((persona) => {
    // Verificar si la persona y sus propiedades están definidas
    if (persona && persona.nombre && persona.legajo) {
      return (
        persona.nombre.toLowerCase().includes(filtroBusqueda.toLowerCase()) ||
        persona.legajo.toLowerCase().includes(filtroBusqueda.toLowerCase())
      );
    } else {
      return false;
    }
  });

  const totalPaginas = Math.max(
    1,
    Math.ceil(personasFiltradas.length / PERSONAS_POR_PAGINA)
  );

  const personasPaginadas = personasFiltradas.slice(
    (paginaActual - 1) * PERSONAS_POR_PAGINA,
    paginaActual * PERSONAS_POR_PAGINA
  );

  useEffect(() => {
    const cargarPersonasAsignadas = async () => {
      try {
        const resultado = await fetchPersonas(ps_id as unknown as number);
        if (!resultado.error) {
          setPersonasAsignadas(resultado.datos);
        } else {
          // Manejar el error como consideres necesario
          console.error(resultado.error);
        }
      } catch (error) {
        console.error("Error al cargar personas asignadas:", error);
      }
    };
    cargarPersonasAsignadas();
  }, [ps_id]);

  useEffect(() => {
    setPaginaActual(1);
  }, [filtroBusqueda]);

  useEffect(() => {
    if (paginaActual > totalPaginas) {
      setPaginaActual(totalPaginas);
    }
  }, [paginaActual, totalPaginas]);

  const handleMedidasCorrectivasChange = (e) => {
    setMedidaCorrectivaSeleccionada(e.target.value);
  };

  const handleCalificacionSeleccionada = (
    e: React.ChangeEvent<{ name?: string; value: unknown }>
  ) => {
    const valor = e.target.value as number;

    setCalificacionesPorPersona((prev) => ({
      ...prev,
      [legajo]: {
        ...prev[legajo],
        [dialogType]: {
          ...prev[legajo]?.[dialogType],
          calificacion: valor,
        },
      },
    }));

    // Actualizar calificación seleccionada
    setCalificacionSeleccionada(valor);

    // Manejo de campos adicionales si la calificación es "Necesita Mejorar"
    if (valor === 4) {
      const medidaCorrectiva =
        calificacionesPorPersona[legajo]?.[dialogType]?.medida_correctiva ||
        null;
      const plazoImplementacion =
        calificacionesPorPersona[legajo]?.[dialogType]?.plazo_implementacion ||
        null;

      setMedidaCorrectivaSeleccionada(medidaCorrectiva);
      setFechaModificada({ fechaModificada: plazoImplementacion });
    } else {
      // Resetea los campos adicionales si la calificación no requiere medidas
      setMedidaCorrectivaSeleccionada(null);
      setFechaModificada({ fechaModificada: null });
    }
  };

  const guardarInformacion = async () => {
    const fiscalizacion = calificacionesPorPersona[legajo]?.[dialogType];

    // Validar si hay calificación seleccionada
    if (!fiscalizacion || !fiscalizacion.calificacion) {
      console.log("Estado actual de fiscalizacion:", fiscalizacion); // Depuración
      present("Selecciona una calificación antes de guardar", 6000);
      return;
    }

    // Validar si es necesario proporcionar medidas correctivas y plazo
    if (fiscalizacion.calificacion === 4) {
      if (!medidaCorrectivaSeleccionada || !fechaModificada.fechaModificada) {
        present(
          "Completa las medidas correctivas y el plazo de implementación",
          6000
        );
        return;
      }
    }

    const informacionAGuardar = {
      calificacion_id: fiscalizacion.calificacion,
      medida_correctiva_id:
        fiscalizacion.calificacion === 4 ? medidaCorrectivaSeleccionada : null,
      plazo_implementacion:
        fiscalizacion.calificacion === 4
          ? fechaModificada.fechaModificada
          : null,
      [dialogType === "Rutinas" ? "actualizar_rutina" : "actualizar_imagen"]:
        fiscalizacion.existe,
    };

    console.log("Payload enviado:", informacionAGuardar);

    let apiFunction;

    switch (dialogType) {
      case "Imagen":
        apiFunction = fetchGuardarMedidasImagen;
        break;
      case "Rutinas":
        apiFunction = fetchMedidasRutinas;
        break;
      case "Procedimiento":
        apiFunction = fetchMedidasProcedimiento;
        break;
      default:
        console.error("Tipo de acción no reconocido:", dialogType);
        return;
    }

    try {
      const response = await apiFunction(fis_id, legajo, informacionAGuardar);

      if (response?.info) {
        setOpenDialog(false);
        present(response.info, 6000);
      } else {
        present(response.error || "Error desconocido al guardar", 6000);
      }
    } catch (error) {
      console.error("Error al guardar la fiscalización:", error);
      present("Error al guardar la fiscalización", 6000);
    }
  };

  const handleOpenDialog = (legajo: number, type: string) => {
    return async () => {
      let apiFunction;
  
      switch (type) {
        case "Imagen":
          apiFunction = fetchGuardarMedidasImagen;
          break;
        case "Rutinas":
          apiFunction = fetchMedidasRutinas;
          break;
        case "Procedimiento":
          apiFunction = fetchMedidasProcedimiento;
          break;
        default:
          console.error("Tipo de acción no reconocido:", type);
          return;
      }
  
      try {
        // Realiza una solicitud GET para obtener datos existentes
        const resultado = await apiFunction(fis_id, legajo);
  
        if (resultado?.datos) {
          const { calificacion, medida_correctiva, plazo_implementacion } = resultado.datos;
  
          // Mapear el texto de calificación al ID correspondiente
          const calificacionId = calificaciones.find(
            (cal) => cal.calificacion === calificacion
          )?.id || null;
  
          // Mapear el texto de medida correctiva al ID correspondiente
          const medidaCorrectivaId = medidasCorrectivas.find(
            (medida) => medida.descripcion === medida_correctiva
          )?.id || null;
  
          // Actualizar el estado con los datos obtenidos
          setCalificacionesPorPersona((prev) => ({
            ...prev,
            [legajo]: {
              ...prev[legajo],
              [type]: {
                calificacion: calificacionId,
                medida_correctiva: medidaCorrectivaId,
                plazo_implementacion: plazo_implementacion || null,
                existe: true,
              },
            },
          }));
  
          // Reflejar datos en los campos del formulario
          setCalificacionSeleccionada(calificacionId);
          setMedidaCorrectivaSeleccionada(medidaCorrectivaId);
          setFechaModificada({ fechaModificada: plazo_implementacion || null });
        } else {
          // Inicializar los datos si no hay un registro previo
          setCalificacionesPorPersona((prev) => ({
            ...prev,
            [legajo]: {
              ...prev[legajo],
              [type]: {
                calificacion: null,
                medida_correctiva: null,
                plazo_implementacion: null,
                existe: false,
              },
            },
          }));
  
          setCalificacionSeleccionada(null);
          setMedidaCorrectivaSeleccionada(null);
          setFechaModificada({ fechaModificada: null });
        }
  
        setDialogType(type);
        setLegajo(legajo);
        setOpenDialog(true);
      } catch (error) {
        console.error("Error al abrir el diálogo:", error);
        present("Error al cargar los datos. Intenta nuevamente.", 6000);
      }
    };
  };
  

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <IonPage>
      <Header titulo="Fiscalización - Personal" />

      <IonContent id="fiscalizacion">
        <div className="fisContainer">
          <div className="fisCard">
            <div className="fisCard_title--area">
              <img src="assets/icon/fisc-COD1.svg" alt="personal" />
              <h1>Personal</h1>
            </div>
            <IonItem>
              <IonInput
                value={filtroBusqueda}
                onIonChange={(e: any) => setFiltroBusqueda(e.detail.value)}
                clearInput={true}
                placeholder="Buscar persona por legajo o nombre"
              ></IonInput>
              <IonIcon icon={search} />
            </IonItem>
            PanelFiscalizacion
            <PanelFiscalizacion />
          </div>

          {personasPaginadas.map((persona) => (
            <div className="fisCard" key={persona.id}>
              <div>
                <h4>Nombre:</h4>
                <p>{persona.nombre}</p>
              </div>
              <div className="d-flex justify-content-between">
                <div>
                  <h4>Legajo:</h4>
                  <p>{persona.legajo}</p>
                </div>
                <div>
                  <h4>Total hs:</h4>
                  <p>{persona.total_asignado}</p>
                </div>
              </div>
              <hr />
              <div>
                <h4>Fiscalizar:</h4>

                <div>
                  {/* Botones para "Imagen", "Rutinas" y "Procedimiento" */}

                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleOpenDialog(
                      parseInt(persona.legajo),
                      "Imagen"
                    )}
                  >
                    Imagen
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleOpenDialog(
                      parseInt(persona.legajo),
                      "Rutinas"
                    )}
                  >
                    Rutinas
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ width: 115 }}
                    onClick={handleOpenDialog(
                      parseInt(persona.legajo),
                      "Procedimiento"
                    )}
                  >
                    Procedimiento
                  </Button>
                </div>
              </div>
            </div>
          ))}
          <div className="fisPagination">
            <button
              type="button"
              className="fisPagination_btn"
              disabled={paginaActual <= 1}
              onClick={() => setPaginaActual((prev) => Math.max(1, prev - 1))}
            >
              Anterior
            </button>
            <span className="fisPagination_text">
              Página {totalPaginas === 0 ? 0 : paginaActual} de {totalPaginas}
            </span>
            <button
              type="button"
              className="fisPagination_btn"
              disabled={paginaActual >= totalPaginas}
              onClick={() =>
                setPaginaActual((prev) => Math.min(totalPaginas, prev + 1))
              }
            >
              Siguiente
            </button>
          </div>
        </div>
        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle>Calificar {dialogType}</DialogTitle>
          <DialogContent className="dialog-content">
            <FormControl className="form-control">
              <InputLabel id="calificacion-imagen">
                Calificar {dialogType}
              </InputLabel>
              <Select
                labelId="calificacion-imagen"
                value={calificacionSeleccionada || ""}
                style={{ width: 250, marginBottom: 5 }}
                onChange={handleCalificacionSeleccionada}
                className={
                  isSubmitted && !calificacionSeleccionada
                    ? "campo-obligatorio"
                    : ""
                }
              >
                {calificaciones.map((cal) => (
                  <MenuItem key={cal.id} value={cal.id}>
                    {cal.calificacion}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {calificacionesPorPersona[legajo]?.[dialogType]?.calificacion ===
              4 && (
              <FormControl style={{ width: 250 }} className="form-control">
                <>
                  <h4>Medidas Correctivas</h4>
                  <Select
                    placeholder="Medidas Correctivas"
                    onChange={handleMedidasCorrectivasChange}
                    value={medidaCorrectivaSeleccionada || ""}
                    className={
                      isSubmitted && !medidaCorrectivaSeleccionada
                        ? "campo-obligatorio"
                        : ""
                    }
                  >
                    {medidasCorrectivas.map((medida) => (
                      <MenuItem key={medida.id} value={medida.id.toString()}>
                        {medida.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                  <h4>Plazo de Implementacion</h4>
                  <IonItem>
                    <DatePicker
                      value={
                        fechaModificada.fechaModificada
                          ? new Date(fechaModificada.fechaModificada)
                          : null
                      }
                      onChange={(date) => {
                        if (date) {
                          setFechaModificada({
                            ...fechaModificada,
                            fechaModificada: date.toISOString().split("T")[0],
                          });
                        } else {
                          setFechaModificada({
                            ...fechaModificada,
                            fechaModificada: null,
                          });
                        }
                      }}
                      format="DD/MM/YYYY"
                      className={
                        isSubmitted && !fechaModificada.fechaModificada
                          ? "campo-obligatorio"
                          : ""
                      }
                    />
                  </IonItem>
                </>
              </FormControl>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              Cancelar
            </Button>
            <Button onClick={guardarInformacion} color="primary">
              Guardar
            </Button>
          </DialogActions>
        </Dialog>
        <div id="comentarioFiscalizacion" className="fisComentario">
          {" "}
          <ComentarioFiscalizacion />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default withRouter(FiscalizarPersonal);
